<vwui-modal-header>
  <div class="w-full flex items-center">
    <h2>Relatie {{relationId ? 'bewerken' : 'toevoegen'}}</h2>
  </div>
</vwui-modal-header>

<vwui-modal-body class="project-modal-body">
  <h3 class="mb-4">Onderneming</h3>
  <vwui-form-group label="Relatietype">
    <app-relation-type-select
      [formControl]="roleControl"
      [readonly]="!!relationId && vwCompanyRoleSelected"
      [excludedRoles]="relationId && !vwCompanyRoleSelected ? [involvedVWCompanyRole] : []"
    ></app-relation-type-select>
  </vwui-form-group>
  @if (vwCompanyRoleSelected) {
    <vwui-form-group label="Onderneming">
      <app-mdm-company-select [formControl]="companyControl"></app-mdm-company-select>
    </vwui-form-group>
  }
  @if (!vwCompanyRoleSelected) {
    <vwui-form-group label="Onderneming">
      <app-custom-company-select [formControl]="companyControl"></app-custom-company-select>
    </vwui-form-group>
  }
  <ng-container [formGroup]="companyFieldsForm">
    <div class="flex gap-4">
      <vwui-form-group class="flex-1">
        <span class="vwui-form-group__label" style="display: flex">
          Straat en huisnummer
          @if (((vwCompanyRoleSelected || existingNonVWCompanySelected) && !isAdmin)) {
            <vwui-tooltip [label]="this.vwCompanyRoleSelected ? vwCompanyInfoLabel : existingNonVWCompanyLabel"
              position="right"
              >
              <img src="/assets/icons/icon-info.svg" class="h-4 w-4" alt="info" style="margin-left: 10px">
            </vwui-tooltip>
          }
        </span>
        <vwui-input formControlName="street"></vwui-input>
      </vwui-form-group>
    </div>
    <div class="flex gap-4">
      <vwui-form-group class="flex-1">
        <span class="vwui-form-group__label" style="display: flex">
          Postcode
          @if (((vwCompanyRoleSelected || existingNonVWCompanySelected) && !isAdmin)) {
            <vwui-tooltip [label]="this.vwCompanyRoleSelected ? vwCompanyInfoLabel : existingNonVWCompanyLabel"
              position="right"
              >
              <img src="/assets/icons/icon-info.svg" class="h-4 w-4" alt="info" style="margin-left: 10px">
            </vwui-tooltip>
          }
        </span>
        <vwui-input formControlName="postalCode"></vwui-input>
      </vwui-form-group>
      <vwui-form-group class="flex-1">
        <span class="vwui-form-group__label" style="display: flex">
          Plaatsnaam
          @if (((vwCompanyRoleSelected || existingNonVWCompanySelected) && !isAdmin)) {
            <vwui-tooltip [label]="this.vwCompanyRoleSelected ? vwCompanyInfoLabel : existingNonVWCompanyLabel"
              position="right"
              >
              <img src="/assets/icons/icon-info.svg" class="h-4 w-4" alt="info" style="margin-left: 10px">
            </vwui-tooltip>
          }
        </span>
        <vwui-input formControlName="city"></vwui-input>
      </vwui-form-group>
    </div>
    <vwui-form-group>
      <span class="vwui-form-group__label" style="display: flex">
        Telefoonnummer
        @if (((vwCompanyRoleSelected || existingNonVWCompanySelected) && !isAdmin)) {
          <vwui-tooltip [label]="this.vwCompanyRoleSelected ? vwCompanyInfoLabel : existingNonVWCompanyLabel"
            position="right"
            >
            <img src="/assets/icons/icon-info.svg" class="h-4 w-4" alt="info" style="margin-left: 10px">
          </vwui-tooltip>
        }
      </span>
      <vwui-input formControlName="phoneNumber"></vwui-input>
    </vwui-form-group>
  </ng-container>

  <ng-container [formGroup]="contactPersonForm">
    <h3 class="mb-4">Contactpersoon</h3>
    <vwui-form-group label="Naam">
      <vwui-input formControlName="contactPersonName"></vwui-input>
    </vwui-form-group>
    <vwui-form-group label="Rol">
      <vwui-input formControlName="contactPersonRole"></vwui-input>
    </vwui-form-group>
  </ng-container>
</vwui-modal-body>

<vwui-modal-footer>
  <vwui-button class="is-light" (click)="modalRef.close()">Annuleren</vwui-button>
  <vwui-button class="is-primary" (click)="save()"
  [disabled]="(formValid$ | async) === false || saving">{{relationId ? 'Opslaan' : 'Toevoegen'}}</vwui-button>
</vwui-modal-footer>
